<template>
  <div>
    <b-button
      size="sm"
      :data-cy="`${dataCy}-selector`"
      v-has-permission="'ED060'"
      v-b-modal="modalName"
      :class="{
        'btn': true,
        'btn-primary': !danger,
        'btn-danger': danger
      }"
    >
      Adjuntar
    </b-button>
    <b-modal
      :id="modalName"
      title="¿Cómo desea adjuntar el documento?"
      @ok="handleOk"
      data-cy="save"
      size="sm"
      centered
      hide-footer
    >
      <div class="space-y-4">
        <upload-file
          :data-cy="`${dataCy}-local`"
          permission="*"
          accept="application/pdf, .doc, .docx, .xlsv, .ppt"
          text="Desde equipo"
          v-model="listLocal"
          upload-to="ed"
          :button-class="{ 'btn-md btn-block': true }"
          container-class="w-100"
          @input="addLocalFile"
        />
        <b-button
          variant="secondary"
          class="btn-block"
          size="md"
          :data-cy="`${dataCy}-repository`"
          v-has-permission="'ED060'"
          v-b-modal="modalName+'-repository'"
        >
          Desde repositorio
        </b-button>
      </div>
    </b-modal>
    <SelectDocRepository
      :modal-id="modalName+'-repository'"
      :files="files"
      :add-file="addLocalFile"
      :remove-file="removeFile"
      :max-files="1"
    />
  </div>
</template>
<script>
import { BButton, BModal } from 'bootstrap-vue';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import SelectDocRepository from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';

export default {
  components: {
    SelectDocRepository,
    UploadFile,
    BButton,
    BModal,
  },
  props: {
    modalName: {
      type: String,
      required: true
    },
    addFile: {
      type: Function
    },
    removeFile: {
      type: Function
    },
    files: {
      type: Array,
      default: () => []
    },
    maxFiles: {
      type: Number
    },
    danger: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: 'select-doc'
    },
  },
  model: {
    prop: 'list',
    event: 'listchange'
  },
  data() {
    return {
      file: {},
    };
  },
  computed: {
    listLocal: {
      get() {
        return this.list;
      },
      set(value) {
        this.$emit('listchange', value);
      }
    }
  },
  methods: {
    handleOk() {},
    async addLocalFile(file, ...args) {
      this.addFile(file, ...args);
      this.$root.$emit('bv::hide::modal', this.modalName);
    },
  }
};
</script>
